// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"5f535759","453":"c2410412","796":"9c14274c"}[chunkId] + ".chunk.js";
};